const question4 = {
    'question': 'Jaki jest koszt jednej sesji terapii EMDR?',
    'answer': 'Cena terapii EMDR w naszym centrum jest zróżnicowana. Aby poznać ceny w poszczególnych naszych placówkach, zapraszam do sekcji Cennik.',
    'answerForCity': 'Cena jednego spotkania w ramach terapii EMDR w naszym centrum #cityLocativeIn# wynosi #priceFirst# zł za jedną sesję psychoterapeutyczną.'
}

export default question4;